/* -disable react/require-default-props */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon';

import './styles.css';

const ToggleContainer = styled.div`
  &.LuftToggle {
    width: 26px;
  }
`;

const IconContainer = styled.div`
  ${({ small }) =>
    small &&
    css`
      &.LuftToggle__circle {
        height: 16px;
        width: 16px;
        margin-top: -8px;
      }
    `}

  && i {
    display: block;
    margin-right: 16px;
    font-size: 10px;
    line-height: 12px;
    text-align: right;
    color: ${({ checked }) => (checked ? '#2580ac' : 'white')};
  }
`;

const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
  border-radius: 4px;

  background-color: ${({ checked }) =>
    checked ? 'rgba(16,119,185, 0.38)' : 'white'};
  opacity: 1;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14),
    0px 1px 3px rgba(0, 0, 0, 0.12);
`;

const ToggleInput = styled.input`
  display: none;

  &:checked + .LuftToggle__circle {
    background-color: var(--luft-secondary);
    transform: translateX(10px);
  }
`;

const CheckBoxLabel = styled.span`
  color: ${({ checked }) =>
    checked ? '#2580ac' : 'rgba(0, 0, 0, 0.54)'} !important;
`;

class LuftToggle extends Component {
  _onClick = e => {
    e.stopPropagation();
    this.checkbox.click();
  };

  render() {
    const { isChecked, input, vertical, iconName, onChange, small, label } =
      this.props;

    return (
      <React.Fragment>
        {label && (
          <CheckBoxLabel
            className="TrackingNFEmailTracking__label"
            checked={input ? input.value : isChecked}
          >
            {label}
          </CheckBoxLabel>
        )}
        <ToggleContainer
          className={`LuftToggle ${vertical ? ' LuftToggle--vertical' : ''} ${
            this.props.className
          }`}
          onClick={this._onClick}
        >
          <Slider checked={input ? input.value : isChecked}>
            <ToggleInput
              ref={el => (this.checkbox = el)}
              type="checkbox"
              checked={input ? input.value : isChecked}
              onChange={input ? input.onChange : onChange}
            />
            <IconContainer
              checked={input ? input.value : isChecked}
              small={small}
              className="LuftToggle__circle"
            >
              {iconName && (
                <Icon className="LuftToggle__circle-icon" name={iconName} />
              )}
            </IconContainer>
          </Slider>
        </ToggleContainer>
      </React.Fragment>
    );
  }
}

LuftToggle.propTypes = {
  isChecked: PropTypes.bool,
  vertical: PropTypes.bool,
  iconName: PropTypes.string,
  onChange: PropTypes.func,
};

export default LuftToggle;
